import { generateUUID } from '@/globals';
import Validatable from '@/validator/Validatable';

export interface IHeaderBidderConfigSSPAPI {
  id: string;
  name: string;
  apiKey: string;
  responseTimeout: number;
  isActive: boolean;
}

export default class HeaderBidderConfigSSP extends Validatable<HeaderBidderConfigSSP, string> {
  id: string = generateUUID();

  name: string;

  apiKey: string;

  responseTimeout: number;

  isActive: boolean;

  revealApiKey: boolean;

  constructor(
    { id, name, apiKey, responseTimeout, isActive } = {
      id: generateUUID(),
      name: '',
      apiKey: '',
      responseTimeout: 200,
      isActive: true,
    },
  ) {
    super();
    this.id = id || generateUUID();
    this.name = name;
    this.apiKey = apiKey;
    this.responseTimeout = responseTimeout;
    this.isActive = isActive;
    this.revealApiKey = false;
  }

  static fromApi(apiObject: IHeaderBidderConfigSSPAPI) {
    return new HeaderBidderConfigSSP({
      id: apiObject.id || generateUUID(),
      name: apiObject.name,
      apiKey: apiObject.apiKey,
      responseTimeout: apiObject.responseTimeout,
      isActive: apiObject.isActive,
    });
  }

  toApi(): IHeaderBidderConfigSSPAPI {
    return {
      id: this.id,
      name: this.name,
      apiKey: this.apiKey,
      responseTimeout: this.responseTimeout,
      isActive: this.isActive,
    };
  }

  static validatorCreateRules() {
    return {
      name: 'required|max:100|not_empty_or_whitespace',
      apiKey: 'required|max:256|not_empty_or_whitespace',
      responseTimeout: 'required|numeric:int|min_value:1',
      isActive: 'required',
    };
  }
}
